import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaginationService<T> {
  private _pageNumber = signal<number>(1);
  private _pageSize = signal<number>(50);
  private _totalCount = signal<number>(0);
  private _items = signal<T[]>([]);

  pageNumber = this._pageNumber.asReadonly();
  pageSize = this._pageSize.asReadonly();
  totalCount = this._totalCount.asReadonly();
  data = this._items.asReadonly();

  totalPages = computed(() => Math.ceil(this._totalCount() / this._pageSize()) || 1);
  hasNext = computed(() => this._pageNumber() < this.totalPages());
  hasPrev = computed(() => this._pageNumber() > 1);

  initialize(pageSize = 50): void {
    this._pageNumber.set(1);
    this._pageSize.set(pageSize);
    this._totalCount.set(0);
    this._items.set([]);
  }

  build(items: T[], totalCount: number): void {
    this._items.set(items);
    this._totalCount.set(totalCount);
  }

  reset(): void {
    this._pageNumber.set(1);
    this._items.set([]);
    this._totalCount.set(0);
  }

  goToPage(page: number): void {
    this._pageNumber.set(page);
  }

  setPageSize(size: number): void {
    this._pageSize.set(size);
    this._pageNumber.set(1);
  }
}
